(() => {
  const BUY_NOW = 'Şimdi Al';
  const ADD_TO_CART = 'Sepete Ekle';
  let ctaObserver = null;
  let ctaTimer = null;
  let ctaResizeTimer = null;
  let ctaBound = false;

  function markHosts({ quoteOnly = false } = {}) {
    document.querySelectorAll('product-info, .product, .product-information').forEach((el) => {
      el.classList.add('craft-pdp');
      if (quoteOnly) el.classList.add('craft-pdp--quote');
    });
    document.documentElement.classList.add('craft-pdp-page');
    document.body?.classList?.add('craft-pdp-page');
  }

  /* ---------------------------------------------------------------
   * CTA row: "Şimdi Al" (outlined orange) + "Sepete Ekle" (solid orange)
   * Same behaviour as standbox-craft.js `_styleCtas`, shared for all crafts.
   * ------------------------------------------------------------- */
  function applyCartCtas() {
    const cellWidth = (el) => {
      const cell =
        el.closest('.accelerated-checkout-block') ||
        el.closest('span:has(add-to-cart-component)') ||
        el.closest('.product-form-buttons > *');
      const w = cell?.getBoundingClientRect?.().width || 0;
      return w > 40 ? Math.floor(w) : 0;
    };

    const stretch = (el) => {
      if (!(el instanceof HTMLElement)) return;
      const px = cellWidth(el);
      // Shopify buy-it-now custom elements ignore % width; pin to the grid cell in px.
      if (px) {
        el.style.setProperty('width', `${px}px`, 'important');
        el.style.setProperty('min-width', `${px}px`, 'important');
        el.style.setProperty('max-width', `${px}px`, 'important');
      } else {
        el.style.setProperty('width', '100%', 'important');
        el.style.setProperty('min-width', '100%', 'important');
        el.style.setProperty('max-width', '100%', 'important');
      }
      el.style.setProperty('flex', '1 1 auto', 'important');
      el.style.setProperty('align-self', 'stretch', 'important');
      el.style.setProperty('box-sizing', 'border-box', 'important');
      el.style.setProperty('display', 'flex', 'important');
    };

    const fixedHeight = (el) => {
      el.style.setProperty('height', '48px', 'important');
      el.style.setProperty('min-height', '48px', 'important');
    };

    document
      .querySelectorAll(
        '.product-form-buttons .accelerated-checkout-block, .product-form-buttons .shopify-payment-button, .product-form-buttons shopify-buy-it-now-button, .product-form-buttons shopify-accelerated-checkout, .product-form-buttons add-to-cart-component, .product-form-buttons > span:has(add-to-cart-component)'
      )
      .forEach((el) => {
        el.classList.add('sb-cta-cell');
        stretch(el);
      });

    document.querySelectorAll('.shopify-payment-button__button').forEach((btn) => {
      if (!(btn instanceof HTMLElement)) return;
      if (btn.textContent.trim() !== BUY_NOW) btn.textContent = BUY_NOW;
      btn.classList.add('sb-cta-buynow');
      stretch(btn);
      fixedHeight(btn);
    });

    document
      .querySelectorAll('.product-form-buttons .add-to-cart-button, .product-form-buttons button[name="add"]')
      .forEach((btn) => {
        if (!(btn instanceof HTMLElement)) return;
        const labelSpan =
          btn.querySelector('.add-to-cart-text__content > span:first-child') ||
          btn.querySelector('.add-to-cart-text__content') ||
          btn.querySelector('[ref="addToCartText"]');
        if (labelSpan) {
          // Keep sibling quantity badge; only set the primary label node.
          if (labelSpan.childElementCount === 0) {
            if (labelSpan.textContent.trim() !== ADD_TO_CART) labelSpan.textContent = ADD_TO_CART;
          } else {
            const first = labelSpan.querySelector(':scope > span:first-child');
            if (first && first.textContent.trim() !== ADD_TO_CART) first.textContent = ADD_TO_CART;
          }
        }
        btn.classList.add('sb-cta-atc');
        stretch(btn);
        fixedHeight(btn);
      });
  }

  function styleCartCtas() {
    applyCartCtas();
    requestAnimationFrame(applyCartCtas);
    if (ctaBound) return;
    ctaBound = true;

    window.addEventListener('resize', () => {
      clearTimeout(ctaResizeTimer);
      ctaResizeTimer = setTimeout(applyCartCtas, 100);
    });

    // Theme buy buttons hydrate late and re-render on variant changes.
    if (typeof MutationObserver !== 'undefined' && document.body) {
      ctaObserver = new MutationObserver(() => {
        clearTimeout(ctaTimer);
        ctaTimer = setTimeout(applyCartCtas, 50);
      });
      ctaObserver.observe(document.body, { childList: true, subtree: true, characterData: true });
    }
  }

  /* ---------------------------------------------------------------
   * Move the print add-on step BELOW the buy buttons
   * (shared port of standbox-craft.js `_placePrintAfterCtas`).
   * ------------------------------------------------------------- */
  function placePrintAfterCtas(host, step) {
    if (!host || !step) return false;
    step.classList.add('craft-print-step--after-cta');

    const root =
      host.closest('.product-details') ||
      document.querySelector('.product-details:has(.craft-pdp-root)') ||
      document.querySelector('.product-information__grid .product-details');
    if (!root) return false;

    const buy =
      root.querySelector('buy-buttons-component') ||
      root.querySelector('.buy-buttons') ||
      root.querySelector('.product-form-buttons');
    if (!buy) return false;

    const anchor =
      buy.closest('.shopify-block') ||
      buy.closest('[data-block-type="buy-buttons"]') ||
      buy;
    if (!anchor.parentElement) return false;
    if (anchor.nextElementSibling === step) return true;
    anchor.insertAdjacentElement('afterend', step);
    return true;
  }

  /** Same as placePrintAfterCtas, retries while the theme buy buttons hydrate. */
  function placePrintAfterCtasWithRetry(host, step) {
    if (!host || !step) return;
    if (placePrintAfterCtas(host, step)) {
      step.classList.add('craft-print-step--placed');
      return;
    }
    [150, 500, 1200, 2500].forEach((ms) => {
      setTimeout(() => {
        if (!step.classList.contains('craft-print-step--placed')) {
          if (placePrintAfterCtas(host, step)) step.classList.add('craft-print-step--placed');
        }
      }, ms);
    });
  }

  /* ---------------------------------------------------------------
   * Print source (upload vs HarfMix service + note) — shared controller.
   * Markup contract: snippets/craft-print-step.liquid  (data-<ns>-*)
   * ------------------------------------------------------------- */
  function createPrintSource(host, ns, { onChange, onService } = {}) {
    const q = (name) => host.querySelector(`[data-${ns}-${name}]`);
    const qa = (name) => Array.from(host.querySelectorAll(`[data-${ns}-${name}]`));

    const ctrl = {
      source: 'upload',
      note: '',
      step: q('print-step'),
      filesEl: q('upload-files'),
      noteWrap: q('service-note'),
      noteEl: q('print-note'),
      inputs: qa('source'),
      get isService() {
        return this.source === 'service';
      },
      noteValue() {
        return String((this.noteEl && this.noteEl.value) || this.note || '').trim();
      },
      reset() {
        this.source = 'upload';
        this.note = '';
        if (this.noteEl) this.noteEl.value = '';
        this.inputs.forEach((el) => {
          el.checked = el.value === 'upload';
        });
      },
      sync(wantPrint) {
        const isService = Boolean(wantPrint) && this.isService;
        if (this.filesEl) this.filesEl.hidden = !wantPrint || isService;
        if (this.noteWrap) this.noteWrap.hidden = !isService;
        this.inputs.forEach((el) => {
          el.checked = el.value === (this.source || 'upload');
        });
      },
    };

    ctrl.inputs.forEach((el) => {
      el.addEventListener('change', () => {
        if (!el.checked) return;
        ctrl.source = el.value === 'service' ? 'service' : 'upload';
        if (ctrl.isService && typeof onService === 'function') onService();
        if (typeof onChange === 'function') onChange();
        if (ctrl.isService) {
          requestAnimationFrame(() => ctrl.noteEl?.focus?.({ preventScroll: true }));
        }
      });
    });

    qa('wa-link').forEach((link) => {
      link.addEventListener('click', (event) => {
        event.stopPropagation();
        const serviceInput = ctrl.inputs.find((el) => el.value === 'service');
        if (serviceInput && !serviceInput.checked) {
          serviceInput.checked = true;
          serviceInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });

    ctrl.noteEl?.addEventListener('input', () => {
      ctrl.note = String(ctrl.noteEl.value || '').trim();
    });

    return ctrl;
  }

  /** Safety net: place any unplaced print step under CTAs (covers craft/CE race). */
  function placeAllPrintSteps() {
    document.querySelectorAll('.craft-print-step:not(.craft-print-step--placed)').forEach((step) => {
      const host =
        step.closest('.craft-pdp-root') ||
        document.querySelector('.product-details .craft-pdp-root') ||
        document.querySelector('.craft-pdp-root');
      if (host) placePrintAfterCtasWithRetry(host, step);
    });
  }

  function initGallery(media) {
    const run = () => {
      if (window.HarfmixCraftGallery && typeof window.HarfmixCraftGallery.init === 'function') {
        window.HarfmixCraftGallery.init({ media: media || [] });
        return true;
      }
      return false;
    };
    if (run()) return;
    [50, 200, 600, 1200].forEach((ms) => setTimeout(run, ms));
  }

  function init(opts = {}) {
    const quoteOnly = !!opts.quoteOnly;
    markHosts({ quoteOnly });
    initGallery(opts.media);
    if (!quoteOnly) {
      styleCartCtas();
      placeAllPrintSteps();
      // Theme buy buttons can hydrate late
      setTimeout(applyCartCtas, 200);
      setTimeout(applyCartCtas, 800);
      setTimeout(placeAllPrintSteps, 400);
      setTimeout(placeAllPrintSteps, 1500);
    }
  }

  window.HarfmixCraftPdp = {
    init,
    initGallery,
    markHosts,
    styleCartCtas,
    placePrintAfterCtas: placePrintAfterCtasWithRetry,
    createPrintSource,
  };
})();
